import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { ContextProvider } from "./context/Context";
import { AuthProvider } from "./context/AuthProvider";
import { ProSidebarProvider } from "react-pro-sidebar";
import { HelmetProvider } from "react-helmet-async";
import ThemeProvider from "./theme";
//import { ThemeProvider, createTheme } from '@mui/material';
import { Provider } from "react-redux";
import store from "../src/redux/app/store";
import { SidebarProvider } from "./context/sidebar/sidebar_context";
import { CoursesProvider } from "./context/courses/courses_context";
import { CartProvider } from "./context/cart/cart_context";
import { WishlistProvider } from "./SAPPages/context/WishlistContext";
import IdleTimerProvider from "./IdleTimerProvider";
import { ProfileProvider } from "./SAPPages/context/ProfileContext";
import { SnackbarProvider } from "./STMPages/components/snackbars/SnackbarContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <HelmetProvider>
        <ThemeProvider>
          <ProSidebarProvider>
            <AuthProvider>
              <ContextProvider>
                <SidebarProvider>
                  <CoursesProvider>
                    <CartProvider>
                      <WishlistProvider>
                        <BrowserRouter>
                          <IdleTimerProvider>
                            <ProfileProvider>
                                <SnackbarProvider> 
                                   <App />
                                  </SnackbarProvider>
                             
                            </ProfileProvider>
                          </IdleTimerProvider>
                        </BrowserRouter>
                      </WishlistProvider>
                    </CartProvider>
                  </CoursesProvider>
                </SidebarProvider>
              </ContextProvider>
            </AuthProvider>
          </ProSidebarProvider>
        </ThemeProvider>
      </HelmetProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
